import { HTMLProps } from "react";

interface ButtonProps extends Omit<HTMLProps<HTMLButtonElement>, "type"> {
  type?: "button" | "submit" | "reset";
}

/**
 * Simple, reusable Button component
 *
 * Usage:
 *   <Button onClick={handleClick}>Primary Button</Button>
 *   <Button className="!bg-mathyellow">Custom color override</Button>
 *   <Button disabled>Disabled</Button>
 */
export default function Button({
  onClick,
  disabled = false,
  children,
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`
        bg-mathyellow hover:mathyellow text-gray-900 border-2 border-transparent
        text-lg font-bold
        px-6 py-2
        rounded-md
        ${className}
        transition-all duration-200 ease-in-out transform
        ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:scale-105 hover:shadow-lg"
        }
      `
        .trim()
        .replace(/\s+/g, " ")}
      {...props}
    >
      {children}
    </button>
  );
}
